import { render, staticRenderFns } from "./decision.vue?vue&type=template&id=c67e4c96&scoped=true"
import script from "./decision.vue?vue&type=script&lang=js"
export * from "./decision.vue?vue&type=script&lang=js"
import style0 from "./decision.vue?vue&type=style&index=0&id=c67e4c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67e4c96",
  null
  
)

export default component.exports